import { Country, CountryDto } from '../model/types/countrySchema';

export const mapCountryFromDto = ({
  id,
  name,
  currency,
  currency_symbol,
}: CountryDto): Country => ({
  id,
  name,
  currency,
  currencySymbol: currency_symbol,
});
